import {z} from 'zod';

export const Vehicle = z.object({
  type: z.number(),
  licensePlate: z.string().nullable(),
  brand: z.string(),
  model: z.string(),
  vin: z.string(),
});

export type Vehicle = z.infer<typeof Vehicle>;

export const OnlineDealVehicleConfigPosition = z.object({
  description: z.string(),
  code: z.string(),
  typeKV: z.number(),
  typeKVString: z.string(),
});

export type OnlineDealVehicleConfigPosition = z.infer<typeof OnlineDealVehicleConfigPosition>;

export const OnlineDealVehicleConfigSummary = z.object({
  description: z.string(),
  positions: z.array(OnlineDealVehicleConfigPosition),
});

export type OnlineDealVehicleConfigSummary = z.infer<typeof OnlineDealVehicleConfigSummary>;
